"use client"

import { Button, Text } from "@radix-ui/themes"
import AddTurboChainButton from "@src/components/AddTurboChainButton"
import Logo from "@src/components/Logo"
import Settings from "@src/components/Settings"
import { FeatureFlagsContext } from "@src/providers/FeatureFlagsProvider"
import dynamic from "next/dynamic"
import { type ReactNode, useContext } from "react"
import styles from "./Header.module.css"

// Prevent hydration mismatch by disabling SSR for wallet component
const ConnectWallet = dynamic(() => import("@src/components/Wallet"), {
  ssr: false,
  loading: () => (
    <Button type={"button"} variant={"solid"} size={"2"} radius={"full"}>
      <Text weight="bold" wrap="nowrap">
        Sign in
      </Text>
    </Button>
  ),
})

export function Header({
  navbarSlot,
  depositSlot,
}: {
  navbarSlot?: ReactNode
  depositSlot?: ReactNode
}) {
  const { whitelabelTemplate } = useContext(FeatureFlagsContext)

  return (
    <>
      <header
        className={`${styles.header} h-[60px] md:h-[80px] fixed top-0 left-0 w-full md:w-[calc(100%-20px)] md:m-[10px] z-[50] bg-veax-greyscale-500`}
      >
        <div className="h-full flex items-center px-5 md:px-8 md:px-5 relative">
          <div className="flex-shrink-0">
            <Logo />
          </div>

          {/* Navbar - VEAX style centered across entire screen */}
          <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div>{navbarSlot}</div>
          </div>

          <div className="flex justify-end items-center gap-4 ml-auto">
            {/* <div className="hidden md:flex">{depositSlot}</div> */}
            {whitelabelTemplate === "turboswap" && (
              <div className="hidden md:block">
                <AddTurboChainButton />
              </div>
            )}
            <ConnectWallet />
            <Settings />
          </div>
        </div>
      </header>
      <div className="h-[60px] md:h-[80px]" />
    </>
  )
}

Header.DisplayNavbar = function DisplayNavbar({
  children,
}: {
  children: ReactNode
}) {
  return <div className="hidden md:flex flex-1 justify-center">{children}</div>
}

Header.DepositSlot = function DepositSlot({
  children,
}: {
  children: ReactNode
}) {
  return (
    <div className="hidden md:flex items-center justify-between">
      {children}
      {/* <div className="h-[20px] w-[1px] bg-gray-5 ml-4" /> */}
    </div>
  )
}
